module.exports = __webpack_public_path__ + "img/logo.1484f71e.png";